import {gsap, Quart} from "gsap";
import $ from 'jquery';
import SwiperC, {Navigation, Autoplay, EffectFade, Virtual, Pagination} from "swiper";
SwiperC.use([ Pagination, Navigation, Autoplay, EffectFade, Virtual ]);
global.$ = global.jQuery = $;
global.gsap = gsap;
global.SwiperC = SwiperC;

global.debug = false;

global.__c__ = function(c){
  if(debug){
    console.log(c);
  }
}

var pow = Math.pow,
  sqrt = Math.sqrt,
  sin = Math.sin,
  cos = Math.cos,
  PI = Math.PI,
  c1 = 1.70158,
  c2 = c1 * 1.525,
  c3 = c1 + 1,
  c4 = ( 2 * PI ) / 3,
  c5 = ( 2 * PI ) / 4.5;
// x is the fraction of animation progress, in the range 0..1
function bounceOut(x) {
  var n1 = 7.5625,
    d1 = 2.75;
  if ( x < 1/d1 ) {
    return n1*x*x;
  } else if ( x < 2/d1 ) {
    return n1*(x-=(1.5/d1))*x + 0.75;
  } else if ( x < 2.5/d1 ) {
    return n1*(x-=(2.25/d1))*x + 0.9375;
  } else {
    return n1*(x-=(2.625/d1))*x + 0.984375;
  }
}
$.extend( $.easing,
  {
    def: 'easeOutQuad',
    swing: function (x) {
      return $.easing[$.easing.def](x);
    },
    easeInQuad: function (x) {
      return x * x;
    },
    easeOutQuad: function (x) {
      return 1 - ( 1 - x ) * ( 1 - x );
    },
    easeInOutQuad: function (x) {
      return x < 0.5 ?
        2 * x * x :
        1 - pow( -2 * x + 2, 2 ) / 2;
    },
    easeInCubic: function (x) {
      return x * x * x;
    },
    easeOutCubic: function (x) {
      return 1 - pow( 1 - x, 3 );
    },
    easeInOutCubic: function (x) {
      return x < 0.5 ?
        4 * x * x * x :
        1 - pow( -2 * x + 2, 3 ) / 2;
    },
    easeInQuart: function (x) {
      return x * x * x * x;
    },
    easeOutQuart: function (x) {
      return 1 - pow( 1 - x, 4 );
    },
    easeInOutQuart: function (x) {
      return x < 0.5 ?
        8 * x * x * x * x :
        1 - pow( -2 * x + 2, 4 ) / 2;
    },
    easeInQuint: function (x) {
      return x * x * x * x * x;
    },
    easeOutQuint: function (x) {
      return 1 - pow( 1 - x, 5 );
    },
    easeInOutQuint: function (x) {
      return x < 0.5 ?
        16 * x * x * x * x * x :
        1 - pow( -2 * x + 2, 5 ) / 2;
    },
    easeInSine: function (x) {
      return 1 - cos( x * PI/2 );
    },
    easeOutSine: function (x) {
      return sin( x * PI/2 );
    },
    easeInOutSine: function (x) {
      return -( cos( PI * x ) - 1 ) / 2;
    },
    easeInExpo: function (x) {
      return x === 0 ? 0 : pow( 2, 10 * x - 10 );
    },
    easeOutExpo: function (x) {
      return x === 1 ? 1 : 1 - pow( 2, -10 * x );
    },
    easeInOutExpo: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        pow( 2, 20 * x - 10 ) / 2 :
        ( 2 - pow( 2, -20 * x + 10 ) ) / 2;
    },
    easeInCirc: function (x) {
      return 1 - sqrt( 1 - pow( x, 2 ) );
    },
    easeOutCirc: function (x) {
      return sqrt( 1 - pow( x - 1, 2 ) );
    },
    easeInOutCirc: function (x) {
      return x < 0.5 ?
        ( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
        ( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
    },
    easeInElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        -pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
    },
    easeOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
    },
    easeInOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        -( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
        pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
    },
    easeInBack: function (x) {
      return c3 * x * x * x - c1 * x * x;
    },
    easeOutBack: function (x) {
      return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
    },
    easeInOutBack: function (x) {
      return x < 0.5 ?
        ( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
        ( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
    },
    easeInBounce: function (x) {
      return 1 - bounceOut( 1 - x );
    },
    easeOutBounce: bounceOut,
    easeInOutBounce: function (x) {
      return x < 0.5 ?
        ( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
        ( 1 + bounceOut( 2 * x - 1 ) ) / 2;
    }
  });


// ScrollAnimatiopn
window.AnimationStart = function($container){
  var _$wait = $($container).find(".wait");
  _$wait.each(function(){
    var __$this = $(this);
    var __delay = __$this.data("delay");
    var __timeout = setTimeout(function(){
      __$this
        .removeClass("wait")
        .addClass("animation");
      clearTimeout(__timeout);
    }, __delay)
  });
};

window.ResetAnimate = function($container){
  // __c__("ResetAnimate");
  var _$animate = $container.find(".animation");
  var _$animating = $container.find(".animated");
  _$animate.each(function(){
    var __$this = $(this);
    __$this
      .addClass("wait")
      .removeClass("animation");
  });
  _$animating.each(function(){
    var __$this = $(this);
    __$this
      .addClass("waiting")
      .removeClass("animated");
  });
};

window.setAnimationContainer = function(){
  let targets = document.querySelectorAll(".animate-container");
  let targetsLen = targets.length;
  let scrollY = window.scrollY;
  let windowHeight = window.innerHeight;
  let timing = windowHeight - (windowHeight / 5);

  for(let i = 0; i < targetsLen; i++){
    let target = targets[i];
    let offsetTop = scrollY + target.getBoundingClientRect().top;

    let delay = target.dataset.delay | 0;
    if(delay === void 0){
      delay = 100;
    }

    if(scrollY + timing >= offsetTop && scrollY <= offsetTop){
      let wait = target.querySelectorAll(".wait");
      wait.forEach(function(el, index){
        gsap.to( el, {
          duration: .1,
          delay : (index * delay) / 1000,
          onComplete: function(){
            el.classList.add("animation");
            el.classList.remove("wait");
          },
        });
      });
    }
  }
  if(targetsLen === 0){
    window.removeEventListener('scroll', setAnimationContainer);
  }
};

window.setAnimation = function(){
  let targets = document.querySelectorAll(".waiting");
  let targetsLen = targets.length;
  let scrollY = window.scrollY;
  let windowHeight = window.innerHeight;
  let timing = windowHeight - (windowHeight / 5);

  for(let i = 0; i < targetsLen; i++){
    let target = targets[i];
    let offsetTop = scrollY + target.getBoundingClientRect().top;

    if(target.classList.value.indexOf("journal-article") > -1) {
      timing = windowHeight - 100;
    }

    if(scrollY + timing >= offsetTop && scrollY <= offsetTop){
      let delay = target.dataset.delay | 0;
      if(delay === void 0){
        delay = 0;
      }
      gsap.to( target, {
        duration: .1,
        delay : delay / 1000,
        onComplete: function(){
          target.classList.add("animated");
          target.classList.remove("waiting");
        },
      });
    }
  }
  if(targetsLen === 0){
    window.removeEventListener('scroll', setAnimation);
  }
};

global._isSP = undefined;

if(window.outerWidth <= 828){
  _isSP = true;
}else{
  _isSP = false;
}

var Init = function(){

  global.mouse_event = {
    "start": _isSP ? "touchstart" : "mousedown",
    "move": _isSP ? "touchmove" : "mousemove",
    "end": _isSP ? "touchend" : "mouseup mouseleave"
  };

  var $window = $(window);
  var $body = $("body").addClass("loaded");
  var $html = $("html");
  var $header = $("header");

  var $nav = $("nav.nav");
  var _navContentDelayTime = 100;
  $nav.find(".wait").each(function(i){
    var _$this = $(this);
    _$this.attr("data-delay", (i * _navContentDelayTime) + 300);
  });

  var $navButton = $(".nav--btn, .nav--close");
  var NavOpenClose = function(){
    if($body.hasClass("nav--open")){
      __c__("NavOpenClose");
      //$body.css({"padding-right": ""});
      $body.removeClass("nav--open");
      $nav.stop().animate({opacity: 0}, 300, function(){
        $nav.css({opacity: ""});
        $nav.find('.nav-content').animate({ scrollTop: 0 }, 0);
        ResetAnimate($nav);
      });
    }else{
      //$body.css({"padding-right": $(window).outerWidth() - $(window).innerWidth()});
      $body.addClass("nav--open");
      AnimationStart($nav);
    }
  };
  $navButton.on("click", NavOpenClose);

  $window.on("scroll", setAnimationContainer);
  $window.on("scroll", setAnimation);

  // Collection Filteringにかぶった固定要素を隠す
  var $filtering = $("#FacetsForm");

  $(".pagetop").on("click", function(){
    $("html, body").stop().animate({scrollTop: 0}, 1000, "easeInOutCirc");
  });

  var Resize = function(){
    if($window.width() <= 828){
      _isSP = true;
    }else{
      _isSP = false;
      if($body.hasClass("nav--open")){
        $body.removeClass("nav--open");
      }
    }

    mouse_event = {
      "start": _isSP ? "touchstart" : "mousedown",
      "move": _isSP ? "touchmove" : "mousemove",
      "end": _isSP ? "touchend" : "mouseup mouseleave"
    };
  };
  $window.on("resize", Resize);
  Resize();

  $(".anchor").on("click", function(){
    var _$this = $(this);
    var href= _$this.attr("href");
    var _$target = $(href);

    var _addPoint = 100;

    if(_isSP) {
      _addPoint = $(".header-content").outerHeight();
    }

    $("html, body").stop().animate({scrollTop: _$target.offset().top - _addPoint}, 1500, "easeInOutQuart");

    if($body.hasClass("nav--open")){
      $body.removeClass("is-modal");
      ResetAnimate($nav);
      $nav.find('.nav-content').animate({ scrollTop: 0 }, 0);
      $body.removeClass("nav--open");
    }
    return false;
  });

  $body.delay(200).queue(function(){
    $body.addClass("loaded").dequeue();
    setAnimation();
    setAnimationContainer();
  });
};

var PreInit = function(){
  Init();
};

window.addEventListener("load", PreInit);

